<template>
  <div v-if="values" class="statistic-bars">
    <div class="statistic-total">{{isCurrentTeamMix && values && values.type !== 'mixed' ? 0 : values.total}}</div>
    <div v-if="values.details && values.details.length >= 4" class="statistic-detail">
      <div class="bars">
        <div 
          v-for="number, index in values.details" 
          :key="`statistic-${values.playerId}-${values.type}-${index}`"
          :style="{
            'height': barHeights[index]+'px',
            'left': (12+17.2*index)+'px', 
            'background': colors[values.type],
            'border-bottom': `1px solid ${colors[values.type]}`}"
          class="bar">
        </div>
        <div 
          v-for="number, index in values.details" 
          :key="`statistic-${values.playerId}-${values.type}-number-${index}`"
          :style="{
            'left': (11+17.2*index)+'px', 
            'color': colors[values.type]}"
          class="number">
          {{isCurrentTeamMix && values && values.type !== 'mixed' ? 0 : number}}
        </div>        
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  data() {
    return {
      colors: {
        'single': '#0072BE',
        'double': '#9364C2',
        'team': '#00A5AF',
        'mixed': '#BF936B',
      },
      barHeights: [0, 0, 0, 0]
    };
  },
  props: {
    "values": {
      type: Object,
      default: {
        playerId: 0,
        type: 'single',
        total: 0,
        details: [0, 0, 0, 0],
        max: 10,
      },
    }
  },
  computed: {
    isCurrentTeamMix() {
      return ['mixed', 'youth_mixed'].includes(this.$store.state.currentTeam)
    }
  },
  watch: {
    values: {
      handler(val) {
        if(val && val.details && val.details.length == 4) {
          
          for(let index=0; index < 4; index++) {
            this.barHeights[index] = this.getBarHeight(val.details[index], val.max)
          }
          // console.log('here')
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getBarHeight(number, max) {
      if(this.isCurrentTeamMix && this.values && this.values.type !== 'mixed')
        return 0
      return max > 0? 45 * number / max : 0
    }
  }
});
</script>
<style lang="less" scoped>
.statistic-bars {
  height: 90px;
  width: 88px;

  .statistic-total {
    width: 100%;
    height: 25px;
    font-family: 'Microsoft YaHei UI';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 30px;
    text-align: center;
    letter-spacing: -0.015em;
    color: #000000;
  }

  .statistic-detail {
    width: 100%;
    height: 74px;

    .bars {
      width: 100%;
      height: 45px;
      position: relative;

      .bar{
        width: 13.2px;
        position: absolute;
        bottom: 0px;
      }

      .number {
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        width: 13.2px;
        letter-spacing: -0.16em;
        position: absolute;
        bottom: -18px;
      }      
    }
  }
}
</style>